<template>
    <div id="novel_main">
        <novelList v-if="novelStatus == 0" :novelList="novelList" :total="total" @toCreate="toCreate" @nextStep="nextStep"
            @copyNovel="copyNovel" @search="search"></novelList>
        <novelChapter v-if="novelStatus == 1" ref="novelChapter" @toNovellist="toNovellist"></novelChapter>
        <novelCreate v-if="novelStatus == 2" @createSuccess="createSuccess" ref="novelCreate" @toList="toNovellist"></novelCreate>
        <novelSuccess v-if="novelStatus == 3" :successNovelId="successNovelId" @toInfo="toInfo" @toList="toNovellist">
        </novelSuccess>
        <novelInfo v-if="novelStatus == 4" ref="noveledit" :successNovelId="successNovelId" @toNovellist="toNovellist"
            @createSuccess="createSuccess"></novelInfo>
        <loadingStatus v-if="loading && novelStatus == 0"></loadingStatus>
    </div>
</template>
<script>
import novelList from '../components/novel_list.vue' //小说列表
import novelChapter from '../components/novel_chapter.vue' //章节管理
import novelCreate from './novel_create.vue'//创建小说，短篇、中长篇页面
import novelSuccess from '../components/novel_success.vue' //创建成功
import novelInfo from '../components/novel_info.vue' //小说信息
import loadingStatus from '../components/loading_status.vue' //小说信息
import api from '@/api/api'
import { EncryptionUtil } from '@/utils/encrypt'
export default {
    components: {
        novelCreate, novelSuccess, novelList, novelChapter, novelInfo, loadingStatus
    },
    data() {
        return {
            novelStatus: '', //0小说列表 1章节列表 2创建短篇，中长篇小说界面 3小说完成 4作品信息,5创建长篇小说的界面
            successNovelId: null, //创建成功小说id
            novelList: [],
            total:0,
            loading: true, //加载
            isCopy: false,// 
        }
    },
    created() {
        //这块是对从其他页面进入到创建页面的入口
        const {lgPage,lgItem,length} = this.$route.query
        if(lgPage){
            this.toNovelCreate(length,lgItem)
            return
        }
        const editItem = JSON.parse(sessionStorage.getItem('editItem'))
        console.log('这是在小说init=', editItem)
        if (editItem) {
            if (editItem.editText) {
                this.novelStatus = 1
                this.$nextTick(() => {
                    if (this.$refs.novelChapter) {
                        sessionStorage.removeItem('editItem');
                        this.$refs.novelChapter.getChapterList(editItem.novelInfo)
                    }
                })
            } else if (editItem.editType) {
                if (editItem.backNum == 1) {
                    this.novelStatus = 0
                    this.getNovellist()
                } else if (editItem.backNum == 2) {
                    this.novelStatus = 3
                    this.successNovelId = editItem.id
                }
                sessionStorage.removeItem('editItem');
            }
        } else {
            let novelId = this.$route.query?.novelId || ''
            let novelInfo = this.$route.query?.novelInfo || {}
            if (novelId) {
                this.novelStatus = 1
                this.$nextTick(() => {
                    if (this.$refs.novelChapter) {
                        this.$refs.novelChapter.getChapterList(EncryptionUtil.decrypt(novelInfo))
                    }
                })
            } else {
                this.novelStatus = 0
                this.getNovellist()
            }
        }
    },
    methods: {
        getNovellist() {
            let novelSearch = JSON.parse(localStorage.getItem(this.nSearchKey)) || {}
            console.log('小说写作列表的筛选条件=',novelSearch)
            novelSearch.pageNum = novelSearch?.pageNum || 1
            novelSearch.pageSize = novelSearch?.pageSize || 20
            api.getNewNovellist(novelSearch).then((res) => {
                // console.log(res)
                if (res.code == 200) {
                    this.novelList = res.rows
                    this.total = res.total
                } else {
                    if (novelSearch) {
                        this.novelList = []
                    }
                }
            }).finally(() => {
                this.loading = false
            })

        },
        //搜索
        search(searchData) {
            this.loading = true
            this.getNovellist(searchData)
        },
        //去创作小说
        toCreate(item) {
            this.novelStatus = 2
            setTimeout(() => {
                if (this.$refs.novelCreate) {
                    this.$refs.novelCreate.getCache(item.length);
                    // this.$set(this.$refs.novelCreate.novelInfo, 'length', item.length)
                }
            }, 20);
        },
        //去创作小说
        toNovelCreate(length,item) {
            this.novelStatus = 2
            setTimeout(() => {
                if (this.$refs.novelCreate) {
                    this.$refs.novelCreate.getNovelInit(length,item);
                }
            }, 20);
        },
        //小说列表
        toNovellist() {
            this.novelStatus = 0
            this.getNovellist()
        },
        //编辑小说信息
        toInfo(id) {
            this.novelStatus = 4
            this.successNovelId = id
        },
        // 生成完成
        createSuccess(id) {
            this.novelStatus = 3
            this.successNovelId = id
        },
        //4 作品克隆-item是当前小说的信息
        copyNovel(item) {
            this.successNovelId = item.id
            this.novelStatus = 4
            this.$nextTick(() => {
                if (this.novelStatus === 4 && this.$refs.noveledit) {
                    this.$refs.noveledit.copy(true)
                }
            })
        },
        // 1,分卷，章节管理 3作品信息 4没有大纲内容进入统一的入口页面
        nextStep(i, item) {
            this.successNovelId = item.id
            if (i == 1) {
                this.novelStatus = 1
                this.$nextTick(() => {
                    if (this.$refs.novelChapter) {
                        this.$refs.novelChapter.getChapterList(item)
                    }
                })
            } else if (i == 3) {
                this.novelStatus = 4
            } else if (i == 4) {
                this.novelStatus = 3
            }
        }
    }
}
</script>
<style>
#novel_main {
    flex: 1;
    height: 100%;
    padding: 16px 20px 0 20px;
}
</style>